const pkg = require('./../../package.json')
const NODE_ENV = process.env.NODE_ENV;

export const getLocalFilePath = (path) => {
  if(NODE_ENV === 'production') return `${pkg.homepage}${path}`
  return path
}

export const getAssetFilePath = (path) => {
  if(NODE_ENV === 'production') return `${pkg.assets}${path}`
  return path
}
